var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPomodoro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.2093 65.1977C6.2093 74.914 14.086 82.7907 23.8023 82.7907H65.1977C74.914 82.7907 82.7907 74.914 82.7907 65.1977V23.8023C82.7907 14.086 74.914 6.2093 65.1977 6.2093H23.8023C14.0859 6.2093 6.2093 14.0856 6.2093 23.8018V36.2209C6.2093 37.9355 4.81929 39.3256 3.10465 39.3256C1.39001 39.3256 0 37.9355 0 36.2209V23.8018C0 10.6561 10.6568 0 23.8023 0H65.1977C78.3432 0 89 10.6567 89 23.8023V65.1977C89 78.3432 78.3432 89 65.1977 89H23.8023C10.6567 89 0 78.3432 0 65.1977V52.7791C0 51.0645 1.39001 49.6744 3.10465 49.6744C4.81929 49.6744 6.2093 51.0645 6.2093 52.7791V65.1977Z",
    fill: "#CACEAC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9787 24.3926C45.6933 24.3926 47.0834 25.7826 47.0834 27.4972V46.6426L62.3997 58.1298C63.7715 59.1585 64.0493 61.1045 63.0206 62.4763C61.9919 63.8481 60.0459 64.1259 58.6741 63.0972L42.9439 51.2996C41.6407 50.3222 40.8741 48.7885 40.8741 47.16V27.4972C40.8741 25.7826 42.2641 24.3926 43.9787 24.3926V24.3926ZM46.6707 46.3329C46.6703 46.3325 46.6698 46.3325 46.6694 46.3321L46.0485 47.16L46.6694 46.3321L46.6707 46.3329Z",
    fill: "#CACEAC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPomodoro);
export default __webpack_public_path__ + "static/media/pomodoro.53afc08dfd1cd48616c772e567ed43c6.svg";
export { ForwardRef as ReactComponent };